export default "__VITE_ASSET__B1L2YSm9__"